import * as React from 'react';

export interface Props {
  name: string;
  children?: React.ReactNode;
}

const Variant: React.SFC<Props> = ({ children }) =>
  children && React.isValidElement(children) ? children : null;

export default Variant;
